'use client';
import React, { useState } from 'react';
import AdminAuthGate from './AdminAuthGate';
import AdminDashboard from './AdminDashboard';

export default function AdminPanelClient() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  if (!isAuthenticated) {
    return <AdminAuthGate onAuthenticated={() => setIsAuthenticated(true)} />;
  }

  return <AdminDashboard onLogout={() => setIsAuthenticated(false)} />;
}